import { useEffect, useState } from "react";
import { getCurrentTheme } from "@next-core/runtime";
export function useCurrentTheme() {
  const [currentTheme, setCurrentTheme] = useState(getCurrentTheme);
  useEffect(() => {
    const listenToThemeChange = event => {
      setCurrentTheme(event.detail);
    };
    window.addEventListener("theme.change", listenToThemeChange);
    return () => {
      window.removeEventListener("theme.change", listenToThemeChange);
    };
  }, []);
  return currentTheme;
}
//# sourceMappingURL=useCurrentTheme.js.map